// 코드값 탭 — 목록(줄마다 {code, label, active})은 설정 뷰가 읽어 넘긴다.

import SettingsCodesEditor, {
  CodeGroupView,
} from "@/modules/org/ui/settings-codes-editor";

interface Props {
  canEdit: boolean;
  groups: CodeGroupView[];
}

const SettingsCodes = ({ canEdit, groups }: Props) => <SettingsCodesEditor canEdit={canEdit} groups={groups} />;

export default SettingsCodes;
